var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopClick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "340px",
    height: "340px",
    viewBox: "0 0 340 340",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "-2.34801062e-15 0 139.999342 0 139.999342 47.8006461 -2.34801062e-15 47.8006461"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-8",
    transform: "translate(-80.000000, -80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(100.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-9",
    fill: "#001425",
    stroke: "#FFFFFF",
    strokeWidth: 19.551
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-6"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 150,
    cy: 150,
    r: 159.7755
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(80.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.795437,45.4348342 C101.795437,44.128222 102.75161,43.0694838 103.933571,43.0694838 C105.115532,43.0694838 106.071705,44.128222 106.071705,45.4348342 C106.071705,54.4828927 112.72381,61.8426396 120.895664,61.8426396 C129.072285,61.8426396 135.724985,54.4828927 135.724985,45.4348342 C135.724985,44.128222 136.680563,43.0694838 137.861928,43.0694838 C139.044485,43.0694838 140.000062,44.128222 140.000062,45.4348342 C140.000062,57.0915024 131.432036,66.5746588 120.895664,66.5746588 C110.364058,66.5746588 101.795437,57.0915024 101.795437,45.4348342 Z",
    id: "Fill-1",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6532975,140 C11.4713365,140 10.5151634,138.940603 10.5151634,137.63399 L10.5151634,65.4156503 C10.5151634,64.1090382 11.4713365,63.0496407 12.6532975,63.0496407 C13.8346627,63.0496407 14.7908358,64.1090382 14.7908358,65.4156503 L14.7908358,135.267981 L125.209465,135.267981 L125.209465,65.4156503 C125.209465,64.1090382 126.166233,63.0496407 127.347599,63.0496407 C128.528964,63.0496407 129.485733,64.1090382 129.485733,65.4156503 L129.485733,137.63399 C129.485733,138.940603 128.528964,140 127.347599,140 L12.6532975,140 Z",
    id: "Fill-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1197194,140 C86.9377584,140 85.9815853,138.940603 85.9815853,137.63399 L85.9815853,82.0469378 L54.0191917,82.0469378 L54.0191917,137.63399 C54.0191917,138.940603 53.0630186,140 51.8810576,140 C50.6996923,140 49.7429235,138.940603 49.7429235,137.63399 L49.7429235,79.680269 C49.7429235,78.374316 50.6996923,77.3149186 51.8810576,77.3149186 L88.1197194,77.3149186 C89.3010846,77.3149186 90.2578534,78.374316 90.2578534,79.680269 L90.2578534,137.63399 C90.2578534,138.940603 89.3010846,140 88.1197194,140",
    id: "Fill-5",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0.000777, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80411703,43.069286 L134.195225,43.069286 L114.610656,4.7318874 L25.3886864,4.7318874 L5.80411703,43.069286 Z M2.13729753,47.8006461 C1.37712504,47.8006461 0.675931451,47.3543411 0.291674981,46.6272002 C-0.0919857436,45.9007186 -0.0967517153,45.0028347 0.274994079,44.2704199 L22.2776983,1.20100204 C22.6577846,0.458698662 23.3673186,-0.000131847848 24.1400018,-0.000131847848 L115.858745,-0.000131847848 C116.631428,-0.000131847848 117.341558,0.458698662 117.721048,1.20100204 L139.724348,44.2704199 C140.096094,45.0028347 140.091328,45.9007186 139.707667,46.6272002 C139.323411,47.3543411 138.621621,47.8006461 137.861449,47.8006461 L2.13729753,47.8006461 Z",
    id: "Fill-11",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 43.069484)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.36535039 C0,1.05873822 0.956173078,0 2.13813407,0 C3.32009506,0 4.27567239,1.05873822 4.27567239,2.36535039 C4.27567239,11.4134089 10.9283732,18.7731558 19.1049934,18.7731558 C27.2816137,18.7731558 33.9337187,11.4134089 33.9337187,2.36535039 C33.9337187,1.05873822 34.889296,0 36.071257,0 C37.253218,0 38.2093911,1.05873822 38.2093911,2.36535039 C38.2093911,14.0220186 29.6407697,23.505175 19.1049934,23.505175 C8.56862142,23.505175 0,14.0220186 0,2.36535039 Z",
    id: "Fill-14"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.9671883,66.5746588 C79.596613,66.5746588 73.186381,61.9309777 70.0003289,55.1474059 C66.8142768,61.9309777 60.4040448,66.5746588 53.0334696,66.5746588 C42.5018635,66.5746588 33.9332421,57.0915024 33.9332421,45.4348342 C33.9332421,44.128222 34.8894152,43.0694838 36.0713762,43.0694838 C37.2533372,43.0694838 38.2095102,44.128222 38.2095102,45.4348342 C38.2095102,54.4828927 44.8616153,61.8426396 53.0334696,61.8426396 C61.2100898,61.8426396 67.8621948,54.4828927 67.8621948,45.4348342 C67.8621948,44.128222 68.8183679,43.0694838 70.0003289,43.0694838 C71.1822899,43.0694838 72.1378672,44.128222 72.1378672,45.4348342 C72.1378672,54.4828927 78.790568,61.8426396 86.9671883,61.8426396 C95.1432128,61.8426396 101.795914,54.4828927 101.795914,45.4348342 C101.795914,44.128222 102.751491,43.0694838 103.933452,43.0694838 C105.115413,43.0694838 106.071586,44.128222 106.071586,45.4348342 C106.071586,57.0915024 97.5029645,66.5746588 86.9671883,66.5746588",
    id: "Fill-17",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.0286942,124.925165 L217.87138,124.925165 C216.80064,137.008149 213.292712,143.049641 207.347599,143.049641 C198.429928,143.049641 191.202126,143.034444 187.536888,138.510923 C183.871651,133.987403 181.739845,133.972206 178.427868,138.510923 C175.115891,143.049641 164.584141,148.257637 161.038914,144.557447 C157.493687,140.857258 153.791847,141.18289 151.895924,136.508055 C150,131.83322 148.674383,141.541834 142.814951,143.049641 C136.955519,144.557447 127.005014,147.588358 124.368172,143.049641 C121.731329,138.510923 117.622385,137.318888 116.712942,132.971659 C116.106647,130.073506 116.106647,127.986418 116.712942,126.710396 C113.116357,138.60843 109.596316,144.557447 106.152821,144.557447 C100.987577,144.557447 89.1218662,144.746838 87.8645992,141.056709 C87.0264212,138.596624 85.0811195,133.219442 82.0286942,124.925165 Z",
    id: "Path-13",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopClick);
export default __webpack_public_path__ + "static/media/shopClick.a5e842699a44b3f9e00b9f6b44dc89b6.svg";
export { ForwardRef as ReactComponent };